module.exports = __webpack_public_path__ + "img/ao.2359a08.svg";